// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DayPicker_wrapper__mnq31","box":"DayPicker_box__31rDX","header":"DayPicker_header__MoOtV","day":"DayPicker_day__3ISye"};